import { FormProvider, useForm } from 'react-hook-form';
import { dsClass } from '../../../../common/constants/dsClasses';
import { PlaceOrderSummaryCoCo } from '../common/PlaceOrderSummaryCoCo.js';
import type { ShoppingBasketType } from '../../../../common/types/shoppingBasketCoCo.js';
import type { PlaceOrderFormDataCoCo } from '../../placeOrderTypesCoCo.js';
import type { StoredPlaceOrderCardPaymentData } from '../../utils/cardPaymentUtilsCoCo.js';

export interface ThankYouSummaryProps {
  shoppingBasket: ShoppingBasketType;
  sessionData: StoredPlaceOrderCardPaymentData;
}

export const ThankYouSummaryCoCo = ({ sessionData, shoppingBasket }: ThankYouSummaryProps) => {
  const methods = useForm<PlaceOrderFormDataCoCo>({
    defaultValues: sessionData.formData,
  });

  return (
    <FormProvider {...methods}>
      <div className={`of-place-order__thank-you-summary ${dsClass.PADDING_TOP_4}`}>
        <PlaceOrderSummaryCoCo shoppingBasket={shoppingBasket} defaultOpen={false} />
      </div>
    </FormProvider>
  );
};
